<template>
  <div>
    <!-- TABS//E -->
    <div class="well text-center cs-info">
      <h3>{{ $t("inquiry.header") }}</h3>
    </div>
    <!-- CS FORM//S -->
    <div class="well cs-regist">
      <div class="cs-rgist-main">
        <div class="tab-design cs">
          <ul>
            <li>
              <router-link
                :to="{ name: 'CsList' }"
                class="router-link-active"
                >{{ $t("inquiry.header") }}</router-link
              >
            </li>
            <li>
              <router-link
                :to="{ name: 'CsList' }"
                class="router-link-deactive"
                >{{ $t("inquiry.inquiryList") }}</router-link
              >
            </li>
          </ul>
        </div>
        <div class="mt20 mb20">
          {{ selectData.notice }}
        </div>
        <div class="mt10">
          <!-- <div v-for="(item, index) in selectData.type" :key="index"> -->
          <vs-select
            class="vs-select-block cs-select"
            :label="$t('inquiry.FAQType')"
            v-model="csSort"
          >
            <vs-select-item
              v-for="(item, index) in selectData.type"
              :key="index"
              :value="item.code"
              :text="item.name"
            />
          </vs-select>
          <vs-input
            :label="$t('inquiry.title')"
            :placeholder="$t('inquiry.enterTitle')"
            class="input-block"
            v-model="title"
          ></vs-input>
          <textarea
            rows="10"
            :placeholder="$t('inquiry.enterContent')"
            class="form-control"
            v-model="contents"
            maxlength="2000"
          ></textarea>

          <div class="text-right limit">
            <span class="txt-black">{{ conComma(contents.length) }}</span> /
            2,000 Byte
          </div>
        </div>
        <!-- <div v-html="nl2br(guide)"></div> -->
        <div v-html="replaceURL(nl2br(guide))"></div>
        <div
          v-if="required"
          class="smallballance-type01 gray-box mt10 pt10 pl10 pr10 pb10"
        >
          <el-checkbox class="popup" v-model="agreeUseInfo"
            >개인정보 수집 · 이용 동의<span class="keycolor"
              >(필수)</span
            ></el-checkbox
          >
          <div v-html="nl2br(required)" />
          <div style="display: flex; line-height: 20px">
            <p class="mr5">{{ "-보유기간 : " }}</p>
            <p v-html="nl2br(period)" style="font-size: 16px; color: #1655a7" />
          </div>
          <div v-html="nl2br(required2)" class="mt10" />
        </div>
      </div>
      <!-- alislide -->
      <div class="recaptcha mt20">
        <div class="allibaba">
          <allibaba
            @send-response-data-event="getResponseData"
            ref="alibaba"
          ></allibaba>
        </div>
      </div>
      <!-- // alislide -->
      <vs-row>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <vs-button
            color="primary"
            type="border"
            class="btn-block"
            onclick="window.history.back()"
            >{{ $t("confirm.cancel") }}</vs-button
          >
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <vs-button
            color="#153ac4"
            type="filled"
            class="btn-block"
            @click="postRegistQna"
            >{{ $t("inquiry.submit") }}</vs-button
          >
        </vs-col>
      </vs-row>
    </div>
    <!-- CS FORM//E -->
    <el-dialog
      title="개인정보 수집 · 이용 동의 안내"
      :visible.sync="agreeNotiPopup"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      class="modal-type01 popup"
      center
    >
      <div class="text-center">
        <p class="text-type01 mgb25">개인정보 수집 · 이용에 동의해 주세요.</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click.prevent="agreeNotiPopup = false">
          {{ $t("confirm.ok") }}
        </span>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Api from "@/common/Api";
import axios from "axios";
import allibaba from "@/components/login/allibaba";

// const hostname = window.location.hostname;
const instance = axios.create({
  baseURL: "https://third.dev.flybit.com",
  timeout: 1000,
});

export default {
  components: {
    allibaba,
  },
  async created() {
    await this.setInit();
  },
  data() {
    return {
      selectData: "",
      agreeNotiPopup: false,
      title: "",
      contents: "",
      guide: "",
      actives: 0,
      csSort: 0,
      required: "",
      required2: "",
      period: "",
      rcapt_sig_key: this.$isDevServer
        ? "6LeiYOAUAAAAADdnn73t4Qwg6jZNhRAA-JGRpzXS"
        : "6LfOpkcUAAAAAG4JscMvBbFfTpRHbPaUJQcE4WYE",
      rcapt_id: null,
      ali_response: null,
      agreeUseInfo: false,
    };
  },
  mounted() {
    // this.initRecaptcha();
    if (this.$refs.alibaba) this.$refs.alibaba.aliSlideReset();
  },
  watch: {
    csSort() {
      let getContents = this.selectData.type.find(
        (data) => data.code === this.csSort
      );
      if (getContents.code) {
        this.contents = getContents.content ? getContents.content : "";
        this.guide = getContents.guide ? getContents.guide : "";
        this.required = getContents.required ? getContents.required : "";
        this.required2 = getContents.required2 ? getContents.required2 : "";
        this.period = getContents.period ? getContents.period : "";
      }
    },
  },
  methods: {
    initRecaptcha() {
      if (!this._.has(window, ["grecaptcha", "render"])) {
        setTimeout(this.initRecaptcha.bind(this), 200);
        return false;
      } else {
        this.rcapt_id = grecaptcha.render(this.$refs.recaptcha, {
          sitekey: this.rcapt_sig_key,
        });
        return true;
      }
    },
    conComma(str) {
      str = String(str);
      if (str >= 1000) {
        return str.replace(/(\d)(?=(?:\d{3})+(?!\d))/g, "$1,");
      } else {
        return str.replace(/[^\d]+/g, "");
      }
    },
    postRegistQna() {
      if (this.csSort === 0) {
        this.csFailNoti("문의 유형을 선택하세요.");
        return false;
      }
      if (!this.title) {
        this.csFailNoti(this.$t("inquiry.enterTitle"));
        return false;
      }
      if (!this.contents) {
        this.csFailNoti(this.$t("inquiry.enterContent"));
        return false;
      }
      // 개인정보 동의 체크
      if (this.required && !this.agreeUseInfo) {
        return (this.agreeNotiPopup = true);
      }

      // 리캡챠 여부 판단
      const g_recaptcha_response =
        this.rcapt_id !== null ? grecaptcha.getResponse(this.rcapt_id) : null;

      const { ali_token, ali_sig, ali_csessionid } = this.ali_response
        ? this.ali_response
        : { ali_token: null, ali_sig: null, ali_csessionid: null };

      if (!this.ali_response) {
        this.csFailNoti("슬라이드를 오른쪽으로 밀어주세요.");
        // this.csFailNoti(this.$t("login.error.captcha"));
        return false;
      }

      Api.Cs.registQna(
        this.csSort,
        this.title,
        this.contents,
        // g_recaptcha_response,
        // this.ali_response.ali_token
        ali_token,
        ali_sig,
        ali_csessionid
      )
        .then((response) => {
          this.$vs.notify({
            title: this.$t("notice.title.notice"),
            text: this.$t("notice.content.inquirySubmitted"),
            type: "warning",
            position: "top-left",
          });

          this.title = "";
          this.contents = "";
          this.csSort = 0;
          this.$router.replace({ name: "CsRegist" });
        })
        .catch((err) => {
          console.log(err);
          // console.log("333");
          if (this.rcapt_id) grecaptcha.reset(this.rcapt_id);
          this.$refs.alibaba.aliSlideReset();

          // grecaptcha.reset(this.rcapt_id);
        });
    },
    csFailNoti(text) {
      this.$vs.notify({
        text,
        position: "top-right",
        color: "danger",
      });
    },
    nl2br(str) {
      return str.replace(/\n/g, "<br />");
    },
    async setInit() {
      try {
        const { data } = await instance.get(`/question/ko`);
        this.selectData = data;
      } catch (error) {
        console.log(error);
      }
    },
    getResponseData(data) {
      if (data) {
        this.ali_response = data;
        this.recaptchaErr = false;
      }
    },
    replaceURL(contents) {
      const URLMatcher = /(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])/gim;

      return contents.replace(
        URLMatcher,
        (match) => `<a href="${match}" target="_blank">${match}</a>`
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.Regist__notification {
  margin: 20px 0;

  .title {
    font-weight: bold;
    font-size: 16px;
    color: #333;
  }

  .items {
    margin-top: 10px;
    padding-left: 20px;

    li {
      list-style: disc;
      color: #333;
      padding: 2px 0;
    }
  }
}
.smallballance-type01.gray-box {
  background-color: #eee;
}
</style>
